import {
  ROCK_WEST_FRESHCHAT_CONFIG,
  DISONA_FRESHCHAT_CONFIG,
} from 'common/constants/freshChat.constants';
import { appConfig } from 'config';
import i18n from './i18n';

const token = process.env.REACT_APP_FRESHCHAT_TOKEN;

const setFcChatButtonHidden = (state) => {
  if (window.fcWidget) {
    window.fcWidget.setConfig({
      headerProperty: {
        hideChatButton: state,
      },
    });
  }
};

export const showFcButton = () => {
  setFcChatButtonHidden(false);
};

export const hideFcButton = () => {
  setFcChatButtonHidden(true);
};

const init = ({
  externalId = '',
  firstName = '',
  email = '',
  phone = '',
  lastName = '',
  restoreId = '',
  updateRestoreId = () => {},
  onChatOpen = () => {},
  onInit = () => {},
} = {}) => {
  let config;
  if (appConfig.whiteLabelPartner === 'rock-west') {
    config = ROCK_WEST_FRESHCHAT_CONFIG;
  } else if (appConfig.whiteLabelPartner === 'disona') {
    config = DISONA_FRESHCHAT_CONFIG;
  }
  if (token) {
    function initFreshChat() {
      onInit();
      window.fcWidget.init({
        firstName,
        lastName,
        email,
        token: '62319273-e126-4903-9a32-ef74e891f04d',
        host: 'https://tempo-remit.freshchat.com',
        widgetUuid: '1304056c-b924-426b-b154-8c27803d8d13',
        phone,
        externalId,
        restoreId,
        faqTags: {},
        tags: ['rock-west'],
        locale: i18n.language,
        ...config,
      });
      window.fcWidget.user.get(function (resp) {
        const status = resp && resp.status;
        const data = resp && resp.data;
        if (status !== 200) {
          window.fcWidget.on('user:created', function (resp) {
            const status = resp && resp.status;
            const data = resp && resp.data;
            if (status === 200) {
              if (data.restoreId) {
                updateRestoreId(data.restoreId);
              }
            }
          });
        }
      });
      window.fcWidget.on('widget:opened', onChatOpen);
    }
    function initialize(i, t) {
      let e;
      i.getElementById(t)
        ? initFreshChat()
        : (((e = i.createElement('script')).id = t),
          (e.async = !0),
          (e.src = 'https://wchat.freshchat.com/js/widget.js'),
          (e.onload = initFreshChat),
          i.head.appendChild(e));
    }
    function initiateCall() {
      initialize(document, 'freshchat-js-sdk');
    }
    initiateCall();
  }
};

export default init;
